"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateNewPasswordForm = void 0;
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
require("./CreateNewPasswordForm.scss");
const CreateNewPasswordForm_scss_json_1 = __importDefault(require("./CreateNewPasswordForm.scss.json"));
const TextField_1 = require("lincd-input/lib/components/TextField");
const Button_1 = require("lincd-mui-base/lib/components/Button");
const Hooks_1 = require("lincd/lib/utils/Hooks");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const package_1 = require("../package");
const useAuth_1 = require("../hooks/useAuth");
function CreateNewPasswordForm(_a) {
    var _b, _c;
    var { token, onPasswordIsReset } = _a, restProps = __rest(_a, ["token", "onPasswordIsReset"]);
    const { register, handleSubmit, getValues, watch, formState: { errors }, } = (0, react_hook_form_1.useForm)();
    const auth = (0, useAuth_1.useAuth)();
    const resetPassword = ({ password, }) => {
        Server_1.Server.call(package_1.packageName, 'resetPassword', password, token).then((res) => {
            if (res.auth && onPasswordIsReset) {
                auth.updateAuth(res.auth, res.accessToken, res.refreshToken);
                onPasswordIsReset();
            }
        });
    };
    restProps = (0, Hooks_1.useStyles)(restProps, CreateNewPasswordForm_scss_json_1.default.root);
    return (react_1.default.createElement("div", Object.assign({}, restProps),
        react_1.default.createElement("form", null,
            react_1.default.createElement("h2", null, "Set A New Password"),
            react_1.default.createElement("div", { className: CreateNewPasswordForm_scss_json_1.default.FormGroup },
                react_1.default.createElement(TextField_1.TextField, Object.assign({ type: 'password', placeholder: "Enter new password", onBlur: () => { } }, register('password', { required: true }))),
                ((_b = errors === null || errors === void 0 ? void 0 : errors.password) === null || _b === void 0 ? void 0 : _b.type) === 'required' && (react_1.default.createElement("p", { className: CreateNewPasswordForm_scss_json_1.default.ErrorMessage }, "Password is required")),
                ((_c = errors === null || errors === void 0 ? void 0 : errors.password) === null || _c === void 0 ? void 0 : _c.type) === 'minLength' && (react_1.default.createElement("p", { className: CreateNewPasswordForm_scss_json_1.default.ErrorMessage }, "Password cannot less than 6 characters")),
                react_1.default.createElement(TextField_1.TextField, Object.assign({ type: 'password', placeholder: "Confirm your password", onBlur: () => { } }, register('confirmPassword', {
                    required: true,
                }))),
                (errors === null || errors === void 0 ? void 0 : errors.confirmPassword) && (react_1.default.createElement("p", { className: CreateNewPasswordForm_scss_json_1.default.ErrorMessage }, "Confirm password is required")),
                watch('confirmPassword') !== watch('password') &&
                    getValues('confirmPassword') ? (react_1.default.createElement("p", { className: CreateNewPasswordForm_scss_json_1.default.ErrorMessage }, "Password did not match")) : null),
            react_1.default.createElement(Button_1.Button, { color: "primary", fullWidth: true, onClick: handleSubmit(resetPassword) }, "Save"))));
}
exports.CreateNewPasswordForm = CreateNewPasswordForm;
exports.default = CreateNewPasswordForm;
//# sourceMappingURL=CreateNewPasswordForm.js.map